import { apiGetCoinById } from '@/Groups/CoinTooltip/private/api/getCoinData';

const CoinTooltip = {
  namespaced: true,

  state: {
    data: null,
    isOpen: false,
    isLoading: false,
    isReady: false,
    currentRequestId: null,
  },

  actions: {
    async init({ state, commit }, coin) {
      const requestId = Date.now() + Math.random();
      commit('SET_REQUEST_ID', requestId);
      commit('SET_DATA', null);
      commit('SET_READY', false);
      commit('SET_LOADING', true);
      try {
        const data = await apiGetCoinById(coin);
        if (state.currentRequestId !== requestId) return;
        commit('SET_DATA', data);
        commit('SET_READY', true);
      } catch (error) {
        console.error('Ошибка загрузки данных монеты:', error);
        if (state.currentRequestId !== requestId) return;
        commit('SET_DATA', null);
        commit('SET_READY', false);  
      } finally {
        if (state.currentRequestId === requestId) {
          commit('SET_LOADING', false);
        }
      }
    },

    //Переключение флага открытия тултипа
    async toggleOpenedFlag({ commit }, status) {
      commit('TOGGLE_OPENED_FLAG', status);
    },

    //Закрытие тултипа и сброс состояния
    async closeTooltip({ state, commit }) {
      if (!state.isOpen) return;
      commit('SET_REQUEST_ID', null);
      commit('TOGGLE_OPENED_FLAG', false);
      commit('SET_LOADING', false);
      commit('SET_READY', false);
      commit('SET_DATA', null);
    }
  },

  mutations: {
    //Переключение флага открытия
    TOGGLE_OPENED_FLAG(state, status) { state.isOpen = status; },
    
    //Установка состояния загрузки
    SET_LOADING(state, status) { state.isLoading = status; },
    
    //Установка готовности данных
    SET_READY(state, status) { state.isReady = status; },
    
    //Сохранение данных монеты
    SET_DATA(state, data) { state.data = data; },
    
    //Сохранение ID текущего запроса
    SET_REQUEST_ID(state, id) { state.currentRequestId = id; }
  },  

  getters: {
    //Получение данных монеты
    getData: (state) => state.data,
    //Получение состояния загрузки
    getIsLoading: (state) => state.isLoading,
    //Получение состояния готовности данных
    getIsReady: (state) => state.isReady,
    //Получение флага открытия тултипа
    getIsOpen: (state) => state.isOpen,
  },
}

export default CoinTooltip;